import { useMemo } from "react";
import { QRCodeSVG } from "qrcode.react";
import { buildKioskQrPayload } from "@/lib/kioskQr";

export default function KioskQrCode({ apiUrl, token, size = 200 }) {
  const payload = useMemo(() => buildKioskQrPayload(apiUrl, token), [apiUrl, token]);
  if (!payload) return null;

  return (
    <div className="flex flex-col items-center gap-3" data-testid="quiosco-qr">
      <div className="rounded-xl border border-zinc-200 bg-white p-4 shadow-sm">
        <QRCodeSVG value={payload} size={size} level="M" includeMargin />
      </div>
      <p className="max-w-xs text-center text-xs text-zinc-500">
        Escanea con la app <b>Quiosco NFC</b> en Ajustes → Escanear QR
      </p>
    </div>
  );
}
